"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = exports.handler = exports.definitions = exports.packageName = void 0;
const package_json_1 = require("./package.json");
Object.defineProperty(exports, "packageName", { enumerable: true, get: function () { return package_json_1.name; } });
const definitions_json_1 = __importDefault(require("./src/definitions.json"));
exports.definitions = definitions_json_1.default;
const validate_1 = require("./src/validate");
Object.defineProperty(exports, "validate", { enumerable: true, get: function () { return validate_1.validate; } });
const handler_1 = __importDefault(require("./src/handler"));
exports.handler = handler_1.default;
exports.default = handler_1.default;
//# sourceMappingURL=index.js.map